import React, { useState, useEffect, useRef, useContext } from "react";
import {
  Button,
  Column,
  Grid,
  DataTable,
  Modal,  
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell, 
  TextInput,
  TextArea,  
  Theme,
} from "@carbon/react";
import { DocumentAttachment } from "@carbon/icons-react";

import {  
  getListInvoiceAttachments,
  getCurrentDoc,
} from "../../services/services";
import SessionController from "../../components/FrontSessionController/SessionController";
import CommodityHeader from "../../components/Header";
import MessageModal from "../../components/MessageModal/MessageModal";
import { ThemeContext } from "../../context/ThemeProvider";
import { useNavigate } from "react-router-dom";

const headers = [
  {
    key: "formtype",
    header: "Form Type",
  },
  {
    key: "status",
    header: "Status",
  },
  {
    key: "suppliernmb",
    header: "Supplier",
  },
  {
    key: "nextapprover",
    header: "Next Approver",
  },
  {
    key: "ctrycode",
    header: "Country",
  },
  {
    key: "compcode",
    header: "Company",
  },
  {
    key: "invonumb",
    header: "Internal Reference",
  },
  {
    key: "deleted",
    header: "Deleted",
  },
  {
    key: "justification",
    header: "Justification",
  },
  {
    key: "user",
    header: "User",
  },
  {
    key: "date",
    header: "Date",
  },
];

const headersApprovalInformation = [
  {
    key: 'rolFE',
    header: 'Approval Role',
  },
  {
    key: 'originalMailApprover',
    header: 'Original Approver Mail',
  },{
    key: 'effectiveApproverMail',
    header: 'Real Approver Mail',
  },{
    key: 'action',
    header: 'Status',
  },
  {
    key: 'actionDate',
    header: 'Approval Date',
  },
  {
    key: 'designatorMail',
    header: 'Invited By',
  }
];

const MinimalDocumentView = () => {
  const navigate = useNavigate();
  const theme = useContext(ThemeContext);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [rows, setRows] = useState([]);

  const [additionalInformation, setAdditionalInformation] = useState("");
  const [messageSessionLost, setMessageSessionLost] = useState("");
  const [messageModal, setMessageModal] = useState("");
  
  const [rowsApprovalInformation, setRowsApprovalInformation] = useState([]);
  const emeaVatSplitEnable = theme.theme.emeaVatSplitEnable;

  //attachments Controllers
  const [approverAttachments, setApproverAttachments] = useState([]);
  const [supplierAttachments, setSupplierAttachments] = useState([]);
  const [accountingTableKey, setAccountingTableKey] = useState(
    "tableAccountingKey0"
  );
  const [rowsApprovalUnit, setRowsApprovalUnit] = useState([]);
  const [rowsAccountinglUnit, setRowsAccountinglUnit] = useState([]);
  const [headersApprovalUnit, setHeadersApprovalUnit] = useState([]);
  const [documentIAS, setDocumentIAS] = useState([]);
  const [sumReceptions, setSumReceptions] = useState();
  const [paymentMethodSelected, setPaymentMethodSelected] = useState("");
  //Start useState for dinamic header tables
  const [headersAccountingUnit, setHeadersAccountingUnit] = useState([]);

  const isForeignInvoice = useRef(false);

  const messageResponse = useRef([]);
  const processingRequest = useRef(false);

  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      // Collect all arguments passed to the debounced function
      clearTimeout(timeout); // Clear any existing timeout
      timeout = setTimeout(() => {
        func.apply(this, args); // Execute the original function with the correct context and arguments
      }, delay);
    };
  }

  const isRequestActive = (enable) => {
    if (enable) {
      if (processingRequest.current) {
        openMessageModal("The request is processing");
        return true;
      }
      document.body.className = "waiting";
      processingRequest.current = enable;
      return false;
    } else {
      processingRequest.current = enable;
      document.body.className = "";
    }
    return false;
  };

  const openMessageModal = (response) => {
    let newMessageResponse = [
      messageResponse.current,
      <br />,
      <br />,
      response,
    ];
    messageResponse.current = newMessageResponse;
    setMessageModal(true);
  };

  const closeMessageModal = () => {
    setMessageModal(false);
    messageResponse.current = [];
  };

  const goBackScreen = () => {
     navigate(-1);
  };

  const closeAdditionalInformation = () => {
    setAdditionalInformation(false);
  };

  const openAdditionalInformation = () => {
    setAdditionalInformation(true);
  };

  const getDocumentAlreadySelected = async () => {
    await getDocumentIAS();    
  };

  const setHeadersForReceptionUnitTable = (documentIas) => {
    let headersAccountingUnit = [];

    let headerAccountingUnit = {};
    headerAccountingUnit.key = "checkbox";
    headerAccountingUnit.header = "";
    headersAccountingUnit.push(headerAccountingUnit);

    headerAccountingUnit = {};
    headerAccountingUnit.key = "account";
    headerAccountingUnit.header = "Account";
    headersAccountingUnit.push(headerAccountingUnit);

    if (
      documentIas.flowType == "NORMAL" ||
      documentIas.flowType == "IPVN" ||
      documentIas.flowType == "NCE"
    ) {
      headerAccountingUnit = {};
      headerAccountingUnit.key = "ponumber";
      headerAccountingUnit.header = "PO Number";
      headersAccountingUnit.push(headerAccountingUnit);

      headerAccountingUnit = {};
      headerAccountingUnit.key = "item";
      headerAccountingUnit.header = "Item";
      headersAccountingUnit.push(headerAccountingUnit);

      headerAccountingUnit = {};
      headerAccountingUnit.key = "description";
      headerAccountingUnit.header = "Description";
      headersAccountingUnit.push(headerAccountingUnit);
    } else {
      if (documentIas.zone === "AP") {
        headerAccountingUnit = {};
        headerAccountingUnit.key = "commodity";
        headerAccountingUnit.header = "Commodity";
        headersAccountingUnit.push(headerAccountingUnit);
      } else {
        headerAccountingUnit = {};
        headerAccountingUnit.key = "invonumb";
        headerAccountingUnit.header = "Intreference";
        headersAccountingUnit.push(headerAccountingUnit);
      }

      headerAccountingUnit = {};
      headerAccountingUnit.key = "description";
      headerAccountingUnit.header = "Commodity Description";
      headersAccountingUnit.push(headerAccountingUnit);
    }
    if (
      documentIas.zone == "AP" ||
      (emeaVatSplitEnable && documentIas.zone == "EMEA")
    ) {
      headerAccountingUnit = {};
      headerAccountingUnit.key = "originalAmount";
      headerAccountingUnit.header = "Original Amount";
      headersAccountingUnit.push(headerAccountingUnit);
    }
    headerAccountingUnit = {};
    headerAccountingUnit.key = "quantity";
    headerAccountingUnit.header = "Quantity";
    headersAccountingUnit.push(headerAccountingUnit);

    headerAccountingUnit = {};
    headerAccountingUnit.key = "amount";
    headerAccountingUnit.header = "Amount";
    headersAccountingUnit.push(headerAccountingUnit);

    headerAccountingUnit = {};
    headerAccountingUnit.key = "total";
    headerAccountingUnit.header = "Total";
    headersAccountingUnit.push(headerAccountingUnit);

    if (
      documentIas.zone == "AP" ||
      (emeaVatSplitEnable && documentIas.zone == "EMEA")
    ) {
      headerAccountingUnit = {};
      headerAccountingUnit.key = "vatcode";
      headerAccountingUnit.header = "VAT";
      headersAccountingUnit.push(headerAccountingUnit);
    }

    setHeadersAccountingUnit(headersAccountingUnit);
  };

  const getDocumentIAS = async () => {
    await getCurrentDoc().then((response) => {
      if (response.status === 200) {
        response.json().then((response) => {          
          console.log("response (getCurrentDoc) DocumentIAS: ", response);
          setChangeInApprovalsForView(response)
          setDocumentIAS(response);
          let rowsToApprovalUnit = [];
          rowsToApprovalUnit.push({
            id: "0",
            rowT: "1",
            docNumb: response.rcpowayb,
            type: response.invoiceTypeDesc,
            netAmount: parseFloat(response.netAmount).toFixed(2).toString(),
            totalAmount: parseFloat(response.totalAmount).toFixed(2).toString(),
          });
          setRowsApprovalUnit(rowsToApprovalUnit);

          let rowForApprovalUnit = getRowForApprovalUnit();
          let headerForApprovalUnit = getheaderForApprovalUnit();
          response.taxesList.map((tax) => {
            headerForApprovalUnit.push({
              key: tax.key.taxecode,
              header: "Tax Amount",
            });
            rowsToApprovalUnit[0][tax.key.taxecode] = parseFloat(tax.taxAmount)
              .toFixed(2)
              .toString();
            rowForApprovalUnit[0][tax.key.taxecode] = tax.key.taxecode;
          });
          rowForApprovalUnit[0]["netAmount"] = parseFloat(response.netAmount)
            .toFixed(2)
            .toString();
          rowForApprovalUnit[0]["totalAmount"] = parseFloat(
            response.totalAmount
          )
            .toFixed(2)
            .toString();
          rowsToApprovalUnit.push(rowForApprovalUnit[0]);
          setHeadersApprovalUnit(headerForApprovalUnit);
          setRowsApprovalUnit(rowsToApprovalUnit);
          let rowsToAccountinglUnit = [];

          response.receptionUnitTable.lRuDAO.map((reception, id) => {
            let quantity = response.receptionUnitTable.aRUQuantity[id];
            reception = getNewReceptionUnit(reception, quantity, id);
            reception = setPurchaseOrderRelatedValues(reception, response, id);
            reception = setSplitByVatsRURelatedValues(reception, response, id);
            if (!reception.description.includes(reception.commodity)) {
              reception.description =
                reception.commodity + " - " + reception.description;
            }
            rowsToAccountinglUnit.push(reception);
          });
          setSumReceptions(
            parseFloat(response.netAmount).toFixed(2).toString()
          );
          setRowsAccountinglUnit(rowsToAccountinglUnit);
          setRowsApprovalInformation(response.approvalRequests);
          setInvoiceRelatedInformationFromJapan(response);
          getInvoiceAttachments(response.idDoc);
          setHeadersForReceptionUnitTable(response);
        });
      } else if (response.status === 410) {
        response.text().then((res) => {
          setMessageSessionLost(res);
        });
      }
    });
  };

  const setChangeInApprovalsForView = (documentIas) => {
    if(documentIas.approvalRequests.length > 0) {
      documentIas.approvalRequests.forEach((item, i) => {
        item.id = i;
        item.effectiveApproverNameFE = item.effectiveApproverName + " => " + item.effectiveApproverMail;
      })
    };
  }

  const setPurchaseOrderRelatedValues = (reception, response, id) => {
    if (response.typeFlow == "NONPO" || response.typeFlow == "NC")
      return reception;
    let item = response.receptionUnitTable.aRUQuantity[id];
    reception["item"] = item;
    let poNumber = response.receptionUnitTable.aRUPONumber[id];
    reception["ponumber"] = poNumber;
    return reception;
  };

  const setInvoiceRelatedInformationFromJapan = (documentIAS) => {
    if (documentIAS.foreingInv != undefined) {
      isForeignInvoice.current = documentIAS.foreingInv === "Y";
    }

    setPaymentMethodSelected(
      documentIAS.payMethodIERP === "" ? "" : documentIAS.payMethodIERP
    );
  };

  const setSplitByVatsRURelatedValues = (reception, response, index) => {
    if (
      !(
        response.zone == "AP" ||
        (emeaVatSplitEnable && response.zone == "EMEA")
      )
    ) {
      return reception;
    }

    reception.vatcode = response.receptionUnitTable.aRUVatCode[index];
    reception.commodity = response.receptionUnitTable.aCommcode[index];
    reception.originalAmount =
      response.receptionUnitTable.aRUAmountFormated[index];
    return reception;
  };

  const getNewReceptionUnit = (reception, quantity, id) => {
    reception["id"] = id + "";
    reception["total"] = quantity * reception.amount;
    reception["quantity"] = quantity;

    return reception;
  };

  const getRowForApprovalUnit = () => {
    return [
      {
        id: "1",
        rowT: "",
        docNumb: "",
        type: "Total",
      },
    ];
  };

  const getheaderForApprovalUnit = () => {
    return [
      {
        key: "rowT",
        header: "Row",
      },
      {
        key: "docNumb",
        header: "Document Number",
      },
      {
        key: "type",
        header: "Type",
      },
      {
        key: "netAmount",
        header: "Net Amount",
      },
      {
        key: "totalAmount",
        header: "Total Amount",
      },
    ];
  };

  const getInvoiceAttachments = (idDoc) => {
    let request = {};
    request.idDoc = idDoc;
    getListInvoiceAttachments(request).then((response) => {
      if (response.status === 200) {
        response.json().then((response) => {
          console.log("response invoice attachments:", response);
          setApproverAttachments(response.approverAttachments);
          setSupplierAttachments(response.supplierAttachments);
        });
      } else if (response.status === 410) {
        response.text().then((res) => {
          setMessageSessionLost(res);
        });
      } else {
        response.text().then((response) => {
          openMessageModal(response);
        });
      }
    });
  };

  useEffect(() => {
    getDocumentAlreadySelected();
  }, [0]);

  return (
    <>
      <Grid>
        <Theme theme="g90">
          <CommodityHeader />
        </Theme>

        <Column lg={16}>
          <TableContainer>
            <Button
              className="style-bttbackID"
              size="lg"
              onClick={goBackScreen}
            >
              Back to List
            </Button>

            <h2 className="style-title-section">1.General Information</h2>
            <Button onClick={openAdditionalInformation}>
              View Additional Information
            </Button>
            <Grid>
              <Column lg={8}>
                <Column className="rows-general-information" lg={8} md={8}>
                  <p className="style-text-docview-idwitherror">
                    <b>Responsible:</b>
                  </p>
                  <TextInput
                    className="style-input-docview-idwitherror"
                    id="text-input-1"
                    type="text"
                    value={documentIAS.firstApproverName}
                    size="md"
                  />
                </Column>
                <Column className="rows-general-information" lg={8} md={8}>
                  <p className="style-text-docview-idwitherror">
                    <b>Reception date:</b>
                  </p>
                  <TextInput
                    className="style-input-docview-idwitherror"
                    id="text-input-1"
                    type="text"
                    value={documentIAS.receptionDate}
                    size="md"
                  />
                </Column>
              </Column>
              <Column lg={8}>
                <Column className="rows-general-information" lg={8} md={8}>
                  <p className="style-text-docview-idwitherror">
                    <b>Approval Status:</b>
                  </p>
                  {documentIAS.flowType === "IPVN" &&
                  documentIAS.docStatus != "RTV" &&
                  documentIAS.docStatus != "HOLD" ? (
                    <TextInput
                      className="style-input-docview-idwitherror"
                      id="text-input-1"
                      type="text"
                      value={""}
                      size="md"
                    />
                  ) : (
                    <TextInput
                      className="style-input-docview-idwitherror"
                      id="text-input-1"
                      type="text"
                      value={documentIAS.docStatus}
                      size="md"
                    />
                  )}
                </Column>
                <Column className="rows-general-information" lg={8} md={8}>
                  {documentIAS.flowType === "NONPO" && documentIAS.zone === "LA" ? (
                    <p className="style-text-docview-idwitherror">
                      Comment:(Please use this section to describe the purchase)
                    </p>
                  ) : (
                    <p className="style-text-docview-idwitherror">
                      <b>Comment:</b>
                    </p>
                  )}
                  <TextArea
                    className="style-input-docview-idwitherror"
                    id="text-area-1"
                    type="text"
                    value={documentIAS.comment}
                    size="md"
                  />
                </Column>
              </Column>

              <Column lg={16} style={{ marginBottom: "10px" }}>
                <Column lg={16} mg={8}>
                  <Column md={4} lg={16} style={{ marginBottom: "12px" }}>
                    <h5>
                      <b>Approver Attachment:</b>
                    </h5>
                  </Column>
                  <Column sm={4} md={8} lg={16}>
                    {approverAttachments.map((row) => (
                      <div
                        style={{ display: "inline-block", marginRight: "10px" }}
                      >
                        <a
                          href="javascript: void(0)"
                          title={"Approver Attachment " + row.key.index}
                          onClick={() =>
                            window.open(
                              row.pathname,
                              "MyWindow",
                              "width=600,height=300"
                            )
                          }
                        >
                          <DocumentAttachment
                            size={42}
                            style={{ display: "block", marginLeft: "35px" }}
                          />
                          <label
                            style={{
                              display: "block",
                              fontSize: "12px",
                              marginLeft: "10px",
                            }}
                          >
                            Open Attachment {row.key.index}
                          </label>
                        </a>
                        <p>
                          <a
                            href={row.pathname}
                            style={{ fontSize: "12px" }}
                            download={"ApproverAttachment-" + row.pathname}
                          >
                            Download Attachment {row.key.index}
                          </a>
                        </p>
                      </div>
                    ))}
                  </Column>
                </Column>
              </Column>
              <Column lg={16}>
                <Column lg={16} mg={8}>
                  <Column md={4} lg={4} style={{ marginBottom: "12px" }}>
                    <h5>
                      <b>Supplier Attachment:</b>
                    </h5>
                  </Column>
                  <Column md={5} lg={5}>
                    {supplierAttachments.map((row) => (
                      <div
                        style={{ display: "inline-block", marginRight: "10px" }}
                      >
                        <a
                          href="javascript: void(0)"
                          title={"Supplier Attachment " + row.key.index}
                          onClick={() =>
                            window.open(
                              row.pathname,
                              "MyWindow",
                              "width=600,height=300"
                            )
                          }
                        >
                          <DocumentAttachment
                            size={42}
                            style={{ display: "block", marginLeft: "35px" }}
                          />
                          <label
                            style={{
                              display: "block",
                              fontSize: "12px",
                              marginLeft: "10px",
                            }}
                          >
                            Open Attachment {row.key.index}
                          </label>
                        </a>
                        <p>
                          <a
                            href={row.pathname}
                            style={{ fontSize: "12px" }}
                            download={"SupplierAttachment-" + row.pathname}
                          >
                            Download Attachment {row.key.index}
                          </a>
                        </p>
                      </div>
                    ))}
                  </Column>
                </Column>
              </Column>
            </Grid>
            <h2 className="style-title-section">1.Unit Information</h2>
            <Grid>
              <Column md={16} lg={16}>
                <h5>
                  <b>A. Approval Unit</b>
                </h5>
              </Column>
              <Column md={16} lg={16}>
                <DataTable
                  key={accountingTableKey}
                  rows={rowsApprovalUnit}
                  headers={headersApprovalUnit}
                  render={({
                    rows,
                    headers,
                    getHeaderProps,
                    getRowProps,
                    getTableProps,
                    getSelectionProps,
                  }) => (
                    <TableContainer className={"style-table-unit-info"}>
                      <Table {...getSelectionProps()} useZebraStyles>
                        <TableHead>
                          <TableRow>
                            {headers.map((header) => (
                              <TableHeader {...getSelectionProps({ header })}>
                                {header.header}
                              </TableHeader>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows.map((row, id) => (
                            <TableRow {...getRowProps({ row })}>
                              {row.cells.map((cell) => (
                                <TableCell key={id}>{cell.value}</TableCell>
                              ))}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                />
              </Column>
            </Grid>
            <Grid>
              <Column md={16} lg={16} style={{ marginBottom: "15px" }}>
                <h5>
                  <b>B.Accounting Unit</b>
                </h5>
              </Column>
              <Column md={16} lg={16}>
                <DataTable
                  rows={rowsAccountinglUnit}
                  headers={headersAccountingUnit}
                  render={({
                    rows,
                    headers,
                    getHeaderProps,
                    getRowProps,
                    getTableProps,
                    getSelectionProps,
                  }) => (
                    <TableContainer className={"style-table-unit-info"}>
                      <Table {...getSelectionProps()} useZebraStyles>
                        <TableHead>
                          <TableRow>
                            {headers.map((header) => (
                              <TableHeader {...getSelectionProps({ header })}>
                                {header.header}
                              </TableHeader>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows.map((row, rowIndex) => (
                            <TableRow {...getRowProps({ row })}>
                              {row.cells.map((cell) => (
                                <>
                                  {cell.id == "".concat(row.id, ":account") ? (
                                    <TableCell
                                      className="style-size-column-modal-rtvlog2"
                                      key={cell.id}
                                    >
                                      {cell.value}
                                    </TableCell>
                                  ) : cell.id ==
                                    "".concat(row.id, ":amount") ? (
                                    <TableCell
                                      className="style-size-column-modal-rtvlog2"
                                      key={cell.id + cell.value}
                                    >
                                      {parseFloat(cell.value).toFixed(2)}
                                    </TableCell>
                                  ) : cell.id ==
                                    "".concat(row.id, ":aRUDescription") ? (
                                    <TableCell
                                      className="style-size-column-modal-rtvlog2"
                                      key={cell.id + cell.value}
                                    >
                                      {parseFloat(cell.value).toFixed(2)}
                                    </TableCell>
                                  ) : cell.id == "".concat(row.id, ":total") ? (
                                    <TableCell
                                      className="style-size-column-modal-rtvlog2"
                                      key={cell.id + cell.value}
                                    ></TableCell>
                                  ) : cell.id ==
                                    "".concat(row.id, ":description") ? (
                                    <TableCell
                                      className="style-size-column-modal-rtvlog2"
                                      id={"description" + cell.id}
                                      key={cell.id + cell.value}
                                    >
                                      {cell.value === "" ? "Empty" : cell.value}
                                    </TableCell>
                                  ) : cell.id ==
                                    "".concat(row.id, ":commodity") ? (
                                    <TableCell
                                      className="style-size-column-modal-rtvlog2"
                                      id={"commodity" + cell.id}
                                      key={cell.id + cell.value}
                                    >
                                      {cell.value === "" ? "Empty" : cell.value}
                                    </TableCell>
                                  ) : (
                                    <TableCell
                                      className="style-size-column-modal-rtvlog2"
                                      key={cell.id + cell.value}
                                    >
                                      {cell.value === "" ? "Empty" : cell.value}
                                    </TableCell>
                                  )}
                                </>
                              ))}
                            </TableRow>
                          ))}
                          <TableRow>
                            <TableCell key="AAk1"></TableCell>
                            <TableCell key="AAk2"></TableCell>
                            <TableCell key="AAk3"></TableCell>
                            <TableCell key="AAk4"></TableCell>
                            <TableCell key="AAk5"></TableCell>
                            {(documentIAS.zone == "AP" ||
                              (emeaVatSplitEnable &&
                                documentIAS.zone == "EMEA")) && (
                              <>
                                <TableCell key="AAk9"></TableCell>
                                <TableCell key="AAk10"></TableCell>
                              </>
                            )}
                            <TableCell key="AAk6" style={{ width: "14rem" }}>
                              <p>
                                <strong>Total: </strong>
                                {parseFloat(documentIAS.netAmount)
                                  .toFixed(2)
                                  .toString()}
                              </p>
                            </TableCell>
                            {parseFloat(sumReceptions) >
                            parseFloat(documentIAS.netAmount) ? (
                              <TableCell
                                key="AAk7"
                                style={{ width: "14rem", color: "#DA1E28" }}
                              >
                                <p>
                                  <strong>Calculated: </strong>
                                  {parseFloat(sumReceptions).toFixed(2)}
                                </p>
                              </TableCell>
                            ) : (
                              <TableCell key="AAk7" style={{ width: "14rem" }}>
                                <p>
                                  <strong>Calculated: </strong>
                                  {parseFloat(sumReceptions).toFixed(2)}
                                </p>
                              </TableCell>
                            )}
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                />
              </Column>
            </Grid>
            <h2 className="style-title-section">3.Approval Information</h2>
            <Grid>
            <Column md={16} lg={16}>
              <DataTable
                isSortable="true"
                rows={documentIAS.approvalRequests ? documentIAS.approvalRequests : []}
                headers={headersApprovalInformation}
                render={({
                  rows,
                  headers,
                  selectedRows,
                  getHeaderProps,
                  getRowProps,
                  getTableProps,
                  getSelectionProps,
                  getBatchActionProps,
                }) => (
                  <TableContainer className={"style-table-approval-info"}>
                    <Table {...getTableProps()} useZebraStyles>
                      <TableHead>
                        <TableRow>
                          
                          {headers.map(header => (
                            <TableHeader {...getHeaderProps({ header })}>
                              {header.header}
                            </TableHeader>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>                        
                        {rows.map((row) => (
                          <TableRow {...getRowProps({ row })}>                            
                            {row.cells.map((cell,index) => (
                              <>
                                <TableCell className='style-size-column-modal-rtvlog2' key={cell.id + cell.value + index}>
                                  {cell.value === "" ? ("") : (cell.value)}
                                </TableCell>
                              </>
                            ))}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>                   
                  </TableContainer>
                )}
              />
            </Column>
            </Grid>
          </TableContainer>
        </Column>
        <Modal
          className="onboarding-modal"
          modalHeading=""
          modalLabel="Invoice Approval System"
          hasscrollingcontent="false"
          onRequestClose={closeAdditionalInformation}
          passiveModal={true}
          onSecondarySubmit={closeAdditionalInformation}
          open={additionalInformation}
          primaryButtonText="Ok"
          secondaryButtonText="Cancel"
          selectorPrimaryFocus="[data-modal-primary-focus]"
          size={"md"}
        >
          <Grid>
            <Column
              lg={16}
              className="classColumnForTableAdditionalInformation"
            >
              <table className="classTableColumnSeparation">
                <tr>
                  <td>
                    <b>Form Type:</b>
                  </td>
                  <td>{documentIAS.flowType}</td>
                </tr>
                <tr>
                  <td>
                    <b>Internal Reference:</b>
                  </td>
                  <td>{documentIAS.invonumb}</td>
                </tr>
                <tr>
                  <td>
                    <b>Country Code:</b>
                  </td>
                  <td>{documentIAS.ctrycode}</td>
                </tr>
                <tr>
                  <td>
                    <b>Company Code:</b>
                  </td>
                  <td>{documentIAS.compcode}</td>
                </tr>
                <tr>
                  <td>
                    <b>Supplier's Name:</b>
                  </td>
                  <td>{documentIAS.supplierName}</td>
                </tr>
                <tr>
                  <td>
                    <b>Invoice number - Suffix:</b>
                  </td>
                  <td>{documentIAS.rcpowayb}</td>
                </tr>
              </table>
              <table className="classTableColumnSeparation">
                <tr>
                  <td>
                    <b>Reception Date:</b>
                  </td>
                  <td>{documentIAS.receptionDate}</td>
                </tr>
                <tr>
                  <td>
                    <b>Export Status:</b>
                  </td>
                  <td>{documentIAS.exported}</td>
                </tr>
                <tr>
                  <td>
                    <b>Export to Caaps Date:</b>
                  </td>
                  <td>{documentIAS.fechaExport}</td>
                </tr>
                <tr>
                  <td>
                    <b>Currency PO:</b>
                  </td>
                  <td>{documentIAS.currencyRU}</td>
                </tr>
                <tr>
                  <td>
                    <b>Currency Invoice:</b>
                  </td>
                  <td>{documentIAS.currencyFC}</td>
                </tr>
                <tr>
                  <td>
                    <b>Exchange rate against dollar:</b>
                  </td>
                  <td>{documentIAS.us_exchange}</td>
                </tr>
              </table>
            </Column>
          </Grid>
        </Modal>

        <SessionController messageLostSessionCallback={messageSessionLost} />
        <MessageModal
          messageCallback={messageResponse.current}
          messageModalCallback={messageModal}
          closeMessageModalCallback={closeMessageModal}
        />
      </Grid>
    </>
  );
};

export default MinimalDocumentView;
